/**
 * Forward subjects deliberately do not inherit reply-thread semantics. Keep a
 * single conventional prefix even when an already-forwarded message is sent on.
 */
export function buildForwardSubject(sourceSubject: string | null | undefined): string {
  const source = (sourceSubject || 'Email').trim();
  const withoutForwardPrefixes = source.replace(/^(?:\s*(?:fw|fwd)\s*:\s*)+/i, '').trim();
  return `Fwd: ${withoutForwardPrefixes || 'Email'}`;
}